import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LeavesDescription.scss';
import vacationIcon from '../../assets/icons/leaveTypes/vacation.svg';
import compensatoryOffIcon from '../../assets/icons/leaveTypes/compensatory-off.svg';
import occasionalLeaveIcon from '../../assets/icons/leaveTypes/occasional-leave.svg';
import sickLeaveIcon from '../../assets/icons/leaveTypes/sick-leave.svg';
import unpaidLeaveIcon from '../../assets/icons/leaveTypes/unpaid-leave.svg';
import childcareExtraIcon from '../../assets/icons/leaveTypes/childcare-extra-leave.svg';
import unpaidMaternityIcon from '../../assets/icons/leaveTypes/unpaid-maternity-leave.svg';
import unpaidParentalIcon from '../../assets/icons/leaveTypes/unpaid-parental-leave.svg';
import unpaidCareLeaveIcon from '../../assets/icons/leaveTypes/unpaid-care-leave.svg';
import forceMajeureIcon from '../../assets/icons/leaveTypes/force-majeure.svg';
import militaryLeaveIcon from '../../assets/icons/leaveTypes/military-leave.svg';
import parentalLeaveIcon from '../../assets/icons/leaveTypes/parental-leave.svg';
import paternityLeaveIcon from '../../assets/icons/leaveTypes/paternity-leave.svg';
import jobSearchIcon from '../../assets/icons/leaveTypes/job-search.svg';
import bloodDonationIcon from '../../assets/icons/leaveTypes/blood-donation.svg';
import absenceGDPRIcon from '../../assets/icons/leaveTypes/absenceGDPR.svg';
import {SegmentedButton, Layout} from '@iba-team/portal-react-components/dist';
import { translationEN, translationRU } from './translations';
import { findTranslationsSelector } from '../../utils/functions';

export const LeavesDescription: FunctionComponent =  () => {
  const [currentLang, setCurrentLang] = useState('en');
  const getTranslationSelector = findTranslationsSelector(currentLang);

  const { t } = useTranslation();

  const translationToUpperCase = (trans: string) => t(trans).toUpperCase();

  const groups = [
    {
      groupName: translationToUpperCase('typesOfHolidays.vacation'),
      leaves:
      [
        { type: getTranslationSelector.vacation,
          description: getTranslationSelector.vacationDescr,
          icon: vacationIcon
        },
        { type: getTranslationSelector.vacationOnDemand,
          description: getTranslationSelector.vacationOnDemandDescr,
          icon: vacationIcon
        }        
      ]
    },

    {
      groupName: translationToUpperCase('typesOfHolidays.sickLeave'),
      leaves:
      [
        { type: getTranslationSelector.sickLeave,
          description: getTranslationSelector.sickLeaveDescr,
          icon: sickLeaveIcon
        },
        {
          type: getTranslationSelector.childcareSickLeave,
          description: getTranslationSelector.childcareSickLeaveDescr,
          icon: sickLeaveIcon,
        }
      ]
    },
    {
      groupName: translationToUpperCase('typesOfHolidays.occasionalLeave'),
      leaves:
      [
        { type:  getTranslationSelector.occasionalLeave,
          description: getTranslationSelector.occasionalLeaveDescr,
          icon: occasionalLeaveIcon
        },
        { type: getTranslationSelector.forceMajeure,
          description: getTranslationSelector.forceMajeureDescr,
          icon: forceMajeureIcon
        },
        { type: getTranslationSelector.jobSearch,
          description: getTranslationSelector.jobSearchDescr,
          icon: jobSearchIcon
        },
        { type: getTranslationSelector.bloodDonation,
          description: getTranslationSelector.bloodDonationDescr,
          icon: bloodDonationIcon
        },
        { type: getTranslationSelector.absenceGDPR,
          description: getTranslationSelector.absenceGDPRDescr,
          icon: absenceGDPRIcon
        }
      ]
    },
    {
      groupName: translationToUpperCase('typesOfHolidays.compensatoryOff'),
      leaves:
      [
        { type: getTranslationSelector.compensatoryOff,
          description: getTranslationSelector.compensatoryOffDescr,
          icon: compensatoryOffIcon
        }
      ]
    },
    {
      groupName: translationToUpperCase('typesOfHolidays.unpaidLeave'),
      leaves:
      [
        { type: getTranslationSelector.unpaidLeave,
          description: getTranslationSelector.unpaidLeaveDescr,
          icon: unpaidLeaveIcon
        },
        { type: getTranslationSelector.unpaidCareLeave,
          description: getTranslationSelector.unpaidCareLeaveDescr,
          icon: unpaidCareLeaveIcon
        }
      ]
    },
    {
      groupName: translationToUpperCase('typesOfHolidays.parentalLeave'),
      leaves:
      [
        { type: getTranslationSelector.maternityLeave,
          description: getTranslationSelector.maternityDescr,
          icon: unpaidMaternityIcon
        },
        { type: getTranslationSelector.unpaidMaternityLeave,
          description: getTranslationSelector.unpaidMaternityDescr,
          icon: unpaidMaternityIcon
        },
        { type: getTranslationSelector.parentalLeave,
          description: getTranslationSelector.parentalLeaveDescr,
          icon: parentalLeaveIcon
        },
        { type: getTranslationSelector.unpaidParentalLeave,
          description: getTranslationSelector.unpaidParentalDescr,
          icon: unpaidParentalIcon
        },
        { type: getTranslationSelector.paternityLeave,
          description: getTranslationSelector.paternityLeaveDescr,
          icon: paternityLeaveIcon
        },
        { type: getTranslationSelector.childcareExtraLeave,
          description: getTranslationSelector.childcareExtraLeaveDescr,
          icon: childcareExtraIcon
        }
      ]
    },
    {
      groupName: translationToUpperCase('typesOfHolidays.militaryLeave'),
      leaves:
      [
        {
          type: getTranslationSelector.militaryLeave,
          description: getTranslationSelector.militaryLeaveDescr,
          icon: militaryLeaveIcon
        }
      ]
    }
  ];

  const renderHeader = () => {
    return {
      layoutName: currentLang === 'en' ? translationEN.absenceDescr : translationRU.absenceDescr,
      right: <SegmentedButton activeItem={currentLang} setActiveItem={e => setCurrentLang(e)} theme={{variant: 'neutral', color: 'grey'}} actionList={[{value: 'en',  text: 'en'}, {value: 'ru',  text: 'ru'}]}/>
    };
  };

  return (
    <Layout className='leaves-description' header={renderHeader()}>
      <p className='linkConfluence'>{ currentLang === 'en' ? translationEN.linkConfluence : translationRU.linkConfluence }</p>
      { groups.map((i, index) => (
        <div className='leave-group'>
          <div className='leave-group-name'>{i.groupName}</div>
          {i.leaves.map((j, index2) => (
            <div key={index}>
              <div className='leave-item__title-wrapper'>
                {j.icon && <img src={ j.icon } alt='icon'/>}
                <div className='leave-item__title'>{ j.type }</div>
              </div>
              <div className='leave-item__descr'>{ j.description }</div>
            </div>
          ))}
        </div>
      ))}
    </Layout>
  );
};
